var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6704_9137",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6704_9137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.42857 10.4787C4.43736 10.3474 3.61813 9.91927 2.97087 9.19429C2.32362 8.46931 2 7.62207 2 6.65259C2 6.13591 2.1055 5.64106 2.31649 5.16803C2.52747 4.695 2.81758 4.27572 3.18681 3.91022L3.5945 4.30519C3.25458 4.61178 2.99909 4.96735 2.82803 5.3719C2.65696 5.77644 2.57143 6.20334 2.57143 6.65259C2.57143 7.46452 2.83993 8.17832 3.37693 8.79401C3.91392 9.40969 4.5978 9.78674 5.42857 9.92513V10.4787ZM6.57143 10.5V9.94642C7.39268 9.7704 8.07418 9.37864 8.61593 8.77112C9.15769 8.1636 9.42857 7.45742 9.42857 6.65259C9.42857 5.72995 9.09524 4.94571 8.42857 4.29986C7.76191 3.65401 6.95238 3.33109 6 3.33109H5.63846L6.55274 4.21682L6.14834 4.60859L4.54396 3.0543L6.14834 1.5L6.55274 1.89177L5.63846 2.77751H6C7.11502 2.77751 8.06044 3.1533 8.83627 3.90489C9.61209 4.65649 10 5.57239 10 6.65259C10 7.61994 9.67454 8.46256 9.02363 9.18045C8.37271 9.89834 7.55531 10.3382 6.57143 10.5Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset-icon.77edb78e325b2e80201aaeefe29357fe.svg";
export { ForwardRef as ReactComponent };